import MenuList from '@mui/material/MenuList';
import React, { useEffect, useMemo, useState } from 'react';
import { MenuOptionDefinition } from 'common/models/MenuDefinition';
import Popper, { PopperPlacementType, PopperProps } from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuOptionRenderer from './MenuOptionRenderer';

interface Props {
  definition: MenuOptionDefinition[];
  sortType?: 'alphabetical' | 'workflow';
  placement?: PopperPlacementType;
  anchorEl: PopperProps['anchorEl'];
  closeHandler: () => void;
}

const sortDefinitionByLabel = (a: MenuOptionDefinition, b: MenuOptionDefinition) =>
  a.label > b.label ? 1 : b.label > a.label ? -1 : 0;

const sortDefinitionByOrderIndex = (a: MenuOptionDefinition, b: MenuOptionDefinition) => {
  const ai = a.orderIndex ?? 99;
  const bi = b.orderIndex ?? 99;
  return ai > bi ? 1 : bi > ai ? -1 : 0;
};

export default function ContextMenu({
  definition,
  sortType = 'alphabetical',
  placement = 'bottom',
  anchorEl,
  closeHandler,
}: Props) {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const sortedDefinition = useMemo(() => {
    if (sortType === 'workflow') return [...definition].sort(sortDefinitionByOrderIndex);
    return [...definition].sort(sortDefinitionByLabel);
  }, [definition, sortType]);

  useEffect(() => {
    if (anchorEl) setHoveredIndex(null);
  }, [anchorEl]);

  return (
    <Popper
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      placement={placement}
      sx={{ zIndex: (t) => t.zIndex.appBar - 2 }}
    >
      <Paper elevation={6}>
        <ClickAwayListener onClickAway={closeHandler}>
          <MenuList>
            {sortedDefinition.map((d, i) => {
              return (
                <MenuOptionRenderer
                  key={i}
                  index={i}
                  hoveredIndex={hoveredIndex}
                  definition={d}
                  subMenuPlacement="right-start"
                  hoveredIndexHandler={setHoveredIndex}
                  closeMenuHandler={closeHandler}
                />
              );
            })}
          </MenuList>
        </ClickAwayListener>
      </Paper>
    </Popper>
  );
}
